// @vendors
const Immutable = require('immutable');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { getStore } = require('core/storeHelper');
const { shouldCoherenceControl } = require('mifid/utilities/mifidValidHelper');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_NONE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_GENERAL_CONCEPTS_ANSWER
} = require('constants/index');

const {
    BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHANGE_FINANCIAL_CULTURE,
    BROKER_CONVENIENCE_MIFID_TEST_CONSULT,
} = require('constants/actionTypes');

const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CONTINUE_WITH_INCOHERENCES,
    BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHECK_INCOHERENCES
} = require('mifid/constants/actionTypes');

// @hardcoded
const getInitialState = () => {
    const INITIAL_STATE = Immutable.fromJS({
        financialCulture: {
            id: '140',
            orden: '2',
            question: formatText(
                'broker-convenienceMifidTestKnowledgeFinancialInstrumentsAndStockMarket'
            ),
            answer: '',
            answers: [
                {
                    id: BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_NONE_ANSWER,
                    description: formatText(
                        'broker-convenienceMifidTestAnswerKnowledgeFinancialInstrumentsAndStockMarketNone'
                    )
                },
                {
                    id: BROKER_CONVENIENCE_MIFID_TEST_SECOND_STEP_FINANCIAL_CULTURE_GENERAL_CONCEPTS_ANSWER,
                    description: formatText(
                        'broker-convenienceMifidTestAnswerKnowledgeFinancialInstrumentsAndStockMarketLow'
                    )
                },
                {
                    id: '143',
                    description: formatText(
                        'broker-convenienceMifidTestAnswerKnowledgeFinancialInstrumentsAndStockMarketMedium'
                    )
                },
                {
                    id: '144',
                    description: formatText(
                        'broker-convenienceMifidTestAnswerKnowledgeFinancialInstrumentsAndStockMarketHigh'
                    )
                }
            ]
        },
        summaryTitle: formatText('broker-convenienceMifidTestFinancialCultureSummaryTitle'),
        summaryDescription: [],
        valid: false,
        validated: false,
        showCoherenceModal: false,
        shouldValidateCoherence: true,
    });

    return INITIAL_STATE
}

function coherenceValidator(immStep) {
    const immPreviousTest = getStore().getState().brokerConsultMiFID.get('questions').toArray();
    const immPreviousFinantialCulture = immPreviousTest.find((immQuestion) => {
        return immQuestion.get('id') === '140'
    })
    const immPreviousFinantialCultureAnswers = !!immPreviousFinantialCulture && immPreviousFinantialCulture.getIn(['respuestasArray', 'respuestasArray']);
    const immPreviousFinantialCultureAnswerSelected = !! immPreviousFinantialCulture &&
        immPreviousFinantialCultureAnswers.toArray().find((immAnswer) => {
            return immAnswer.get("seleccionado") === "S";
        });
    const finantialCultureAnswers = !!immPreviousFinantialCulture && immStep.getIn(['financialCulture','answers']).toArray();
    const finantialCultureIsCoherent = !immPreviousFinantialCulture || !immPreviousFinantialCultureAnswerSelected
        ? true
        : finantialCultureAnswers.indexOf(finantialCultureAnswers.find((answer)=> answer.get('id') === immPreviousFinantialCultureAnswerSelected.get('id'))) <=
            finantialCultureAnswers.indexOf(finantialCultureAnswers.find((answer)=> answer.get('id') === immStep.getIn(['financialCulture', 'answer'])));
    return finantialCultureIsCoherent;
}

function validateStep(immStep) {
    const financialCultureAnswered = !!immStep.getIn(['financialCulture', 'answer']);
    let coherence = true;
    let shouldValidateCoherence = immStep.get('shouldValidateCoherence');
    if (shouldCoherenceControl() && shouldValidateCoherence && financialCultureAnswered) {
        coherence = coherenceValidator(immStep);
        shouldValidateCoherence = !coherence;
    }
    return immStep
        .set('valid', financialCultureAnswered && coherence)
        .set('showCoherenceModal', !coherence)
        .set('shouldValidateCoherence', shouldValidateCoherence)
        .set('validated', true);
}

function changeFinancialCulture(immState, financialCulture) {
    return immState
    .setIn(['financialCulture', 'answer'], financialCulture)
    .set('shouldValidateCoherence', true);
}

function updateSummary(immState) {
    if (!immState.get('valid')) {
        return immState;
    }

    const immFinancialCulture = immState.get('financialCulture');
    const financialCultureAnswer = immFinancialCulture.get('answer');
    const immFinancialCultureDescription = immFinancialCulture
        .get('answers')
        .find(immAnswer => immAnswer.get('id') === financialCultureAnswer);

    return immState.set(
        'summaryDescription',
        Immutable.fromJS([immFinancialCultureDescription.get('description')])
    );
}

const consult = (questions) => {
    const immState = getInitialState()
    const immQuestions = Immutable.fromJS(questions);

    const financialCultureQuestionId = immState.getIn(['financialCulture', 'id']);
    const immFinancialCultureQuestion = immQuestions.find(
        immQuestion => immQuestion.get('id') == financialCultureQuestionId
    );
    const immFinancialCultureAnswer = immFinancialCultureQuestion
        .getIn(['respuestasArray', 'respuestasArray'])
        .find(immAnswer => immAnswer.get('seleccionado') === 'S');

    return immState.setIn(['financialCulture', 'answer'], immFinancialCultureAnswer.get('id'));
};

function closeIncoherenceModal(immState) {
    return immState.set('showCoherenceModal', false)
}

function continueWithIncoherences(immState) {
    return immState
        .set('valid', true)
        .set('shouldValidateCoherence', false)
        .set('showCoherenceModal', false)
}

function brokerConvenienceMiFIDTestStep2(state = getInitialState(), action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_CONSULT:
            return consult(action.payload.questions);
        case BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP:
            return updateSummary(validateStep(state));
        case BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHANGE_FINANCIAL_CULTURE:
            return changeFinancialCulture(state, action.payload.financialCulture);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP2_CHECK_INCOHERENCES:
            return closeIncoherenceModal(state);
        case BROKER_CONVENIENCE_MIFID_TEST_STEP2_CONTINUE_WITH_INCOHERENCES:
            return updateSummary(continueWithIncoherences(state));
        default:
            return state;
    }
}

module.exports = brokerConvenienceMiFIDTestStep2;
